/**
 * MED-1653: a website typed by a manager, with or without "https://". Empty is accepted (the field
 * is optional); "pas-une-url" is not: it needs a host with a dot and no spaces.
 */
export const isValidWebsite = (value: string | null | undefined): boolean => {
  const trimmed = (value ?? "").trim();
  if (trimmed === "") return true;
  if (/\s/.test(trimmed)) return false;
  try {
    const url = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`);
    return (
      (url.protocol === "http:" || url.protocol === "https:") &&
      /^[^.]+(\.[^.]+)+$/.test(url.hostname) &&
      /\.[a-z]{2,}$/i.test(url.hostname)
    );
  } catch {
    return false;
  }
};
